/* eslint-disable @typescript-eslint/consistent-type-assertions */
import clsx from 'clsx'

export type CircularProgressProps = {
  percentage: number
  renderPercentage?: boolean
  percentageTextClassName?: string
  size?: number
  thickness?: number
  loading?: boolean
}

const DEFAULT_SIZE = 128
const DEFAULT_THICKNESS = 12

export function CircularProgress (props: CircularProgressProps) {
  const { percentage, size, thickness, renderPercentage, percentageTextClassName } = props
  return (
    <div className="relative">
      <div
        id='file-radial-progress'
        className={clsx(
          'radial-progress relative z-10',
          getColorByPercentage(percentage),
          percentage <= 0 && 'text-neutral-100'
        )}
        style={{
          '--value': percentage,
          '--size': (size ?? DEFAULT_SIZE) + 'px',
          '--thickness': thickness ?? DEFAULT_THICKNESS + 'px'
        } as React.CSSProperties}
        role="progressbar"
      >
        <div className={clsx('flex items-end', !renderPercentage && 'opacity-0')}>
          <p className={clsx('font-bold', percentageTextClassName ?? 'text-2xl text-neutral')}>{percentage}</p>
          <p className={clsx(percentageTextClassName ?? 'text-2xl text-neutral')}>%</p>
        </div>
      </div>
      <div
        className="radial-progress absolute left-0 text-neutral-100 z-0"
        style={{
          '--value': 100,
          '--size': (size ?? DEFAULT_SIZE) + 'px',
          '--thickness': thickness ?? DEFAULT_THICKNESS + 'px'
        } as React.CSSProperties}
      />
    </div>
  )
}

function getColorByPercentage (percentage: number): string {
  if (percentage >= 90) {
    return 'text-red-500'
  }
  if (percentage >= 75) {
    return 'text-amber-500'
  }
  if (percentage >= 50) {
    return 'text-yellow-500'
  }
  if (percentage >= 30) {
    return 'text-lime-500'
  }

  return 'text-green-500'
}
